import React from 'react';

const Map = () => {
  return (
    <div className="maps" style={{ textAlign: 'center', padding: '20px', borderRadius:'16px' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.960315443808!2d80.9853555!3d26.777534900000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be3273022ee07%3A0x2cf4a3f24eb17025!2sDr%20Manish%20Khattar!5e0!3m2!1sen!2sin!4v1735731686601!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
    </div>
  );
};

export default Map;
